import { modifier } from 'ember-modifier';

export default modifier(function hideTippyOnClick(element, [tippyInstance]) {
  const hideTippy = () => {
    tippyInstance?.hide();
  };
  element.addEventListener('click', hideTippy);
  return () => {
    element.removeEventListener('click', hideTippy);
  };
});
